
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/newsroom",
      function () {
        return require("private-next-pages/preview/newsroom/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/newsroom"])
      });
    }
  